import Vue from "vue";

const filterPretty = (value: string): string => {
  if (!value) return "";
  const prettyJson = JSON.stringify(JSON.parse(value), null, 2);
  console.log(prettyJson);
  return prettyJson;
};

Vue.filter("pretty", filterPretty);

export { filterPretty };
